import { apiRequests } from '../utilities/axios-factory'
import store from '../store'

const REPORT_TYPE_LABELS = {
  distance_travelled: 'Distance Travelled',
  ticket_revenue: 'Ticket Revenue'
}

function formatReportTypeAsLabel (reportType) {
  if (!reportType) {
    return ''
  }

  return String(reportType)
    .split('_')
    .filter((segment) => segment)
    .map((segment) => {
      return segment.charAt(0).toUpperCase() + segment.slice(1)
    })
    .join(' ')
}

function getReportTypeLabel (reportType) {
  if (REPORT_TYPE_LABELS[reportType]) {
    return REPORT_TYPE_LABELS[reportType]
  }

  return formatReportTypeAsLabel(reportType)
}

function getAuthHeaders () {
  return { 'Authorization': store.getters.getTokenId }
}

function getReportTypes () {
  return apiRequests.get('/v1/report-record-source/report-types/', {
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function getReportSummary ({ reportType, category, categoryId, dateStart, dateEnd } = {}) {
  return apiRequests.get('/v1/report-record-source/report-summary/', {
    params: { reportType, category, categoryId, dateStart, dateEnd },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function getRecordsByDataProperty ({ target, reportType, sortOrder, propertyType, periodStart, periodEnd, dataProperty, categoryIds, limit, offset } = {}) {
  return apiRequests.get('/v1/report-record-source/records-by-data-property/', {
    params: { target, reportType, sortOrder, propertyType, periodStart, periodEnd, dataProperty, categoryIds, limit, offset },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function requestReports ({ reportType, target, reportFidelity, category, categoryId, dateStart, dateEnd, recalculate }) {
  return apiRequests.post('/v1/report-record-source/request-reports/', {
    reportType,
    target,
    reportFidelity,
    category,
    categoryId,
    dateStart,
    dateEnd,
    recalculate
  }, {
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function findSourceRecords (filter) {
  return apiRequests.get('/v1/report-record-source/', {
    params: { filter: filter },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function countSourceRecords (where) {
  return apiRequests.get('/v1/report-record-source/count/', {
    params: { where: where },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function findAggregateRecords (filter) {
  return apiRequests.get('/v1/report-record-aggregate/', {
    params: { filter: filter },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function countAggregateRecords (where) {
  return apiRequests.get('/v1/report-record-aggregate/count/', {
    params: { where: where },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function findCustomRecords (filter) {
  return apiRequests.get('/v1/report-record-custom/', {
    params: { filter: filter },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function countCustomRecords (where) {
  return apiRequests.get('/v1/report-record-custom/count/', {
    params: { where: where },
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function archiveSourceRecord (id) {
  return apiRequests.post(`/v1/report-record-source/${encodeURIComponent(id)}/archive/`, {}, {
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function archiveAggregateRecord (id) {
  return apiRequests.post(`/v1/report-record-aggregate/${encodeURIComponent(id)}/archive/`, {}, {
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

function archiveCustomRecord (id) {
  return apiRequests.post(`/v1/report-record-custom/${encodeURIComponent(id)}/archive/`, {}, {
    headers: getAuthHeaders()
  }).then((result) => result.data)
}

export {
  REPORT_TYPE_LABELS,
  getReportTypeLabel,
  getReportTypes,
  getReportSummary,
  getRecordsByDataProperty,
  requestReports,
  findSourceRecords,
  countSourceRecords,
  findAggregateRecords,
  countAggregateRecords,
  findCustomRecords,
  countCustomRecords,
  archiveSourceRecord,
  archiveAggregateRecord,
  archiveCustomRecord
}
